const ACTIONS = {
  GET_RESULTS: "GET_RESULTS",
  GET_IDEA: "GET_IDEA",
  CREATE_IDEA: "CREATE_IDEA",
  FAILED_TO_SUBMIT_IDEA: "FAILED_TO_SUBMIT_IDEA",
  PROCESS_SUBMITTING_IDEA: "PROCESS_SUBMITTING_IDEA",
  SUBMISSION_COMPLETE: "SUBMISSION_COMPLETE",
  LOGIN: "LOGIN",
  REGISTER: "REGISTER",
  LOGOUT: "LOGOUT",
  SET_MODE: "SET_MODE",
  POST_COMMENT: "POST_COMMENT",
  GET_TAGS: "GET_TAGS",
  DRAFT_IDEA: "DRAFT_IDEA",
  SET_READ: "SET_READ",
  RESET_IDEA_DETAIL: "RESET_IDEA_DETAIL",
  CLAP: "CLAP",
  TOGGLE_USER_SELECTED_TAG: "TOGGLE_USER_SELECTED_TAG",
  NOTIFICATION: "NOTIFICATION",
  CLEAR_NOTIFICATION: "CLEAR_NOTIFICATION",
  SET_RENDER: "SET_RENDER"
};

export default ACTIONS;
